module.exports = "img/flags/NZ.c045ba5.png";